import { Plus } from "lucide-react"
import "./TranscriptProcessing.css"
import { useNavigate } from "react-router-dom"

export default function TranscriptProcessing({ createNewSession,setActiveComponent,setPatientId }) {
  const navigate= useNavigate()
  return (
    <div className="transcript-processing">
      <h2 className="processing-title">Generating your transcript...</h2>
      <p className="processing-subtitle">
        You can start recording your next session while we process the transcript in the background.
      </p>
      <button className="start-session-button" onClick={()=>{
        createNewSession()
        navigate("/dashboard")
        setActiveComponent("recording-uploading")
        setPatientId(null)
      }}>
        <Plus className="button-icon" />
        Start session
      </button>
    </div>
  )
}

